import React, {Component} from "react";
import {ErrorMessage} from "../styles/ErrorMessage";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import DOMPurify from "dompurify";


class Error extends Component {
    constructor(props) {
        super(props);
        this.props = props;
    }

    prepareStr = (str) => {
        // Handle undefined, null, or empty values
        if (!str && str !== 0) {
            return <span></span>; // Return empty span for undefined/null/empty strings
        }

        if (typeof str === "object") {
            str = JSON.stringify(str);
        }

        // Convert to string if it's not already (handles numbers, booleans, etc.)
        str = String(str);

        let replacedString = str.replace(/,/g, ",<br>");
        replacedString = replacedString.replace(/\\n/g, "<br>");
        const sanitizedReplacedString = DOMPurify.sanitize(replacedString);
        return (
            <span dangerouslySetInnerHTML={{__html: sanitizedReplacedString}}></span>
        )
    };

    render() {
        // Provide default values for undefined props
        const errorCode = this.props.errorCode || '';
        const errorMessage = this.props.errorMessage || 'Unknown error occurred';
        const errorDetails = this.props.errorDetails || '';

        // Build the error display string, handling concatenation safely
        const mainErrorText = `${errorCode}${errorCode && errorMessage ? ' ' : ''}${errorMessage}`;

        return(
            <ErrorMessage>
                <div>
                    <FontAwesomeIcon
                        icon={"exclamation-circle"}
                        className={"exclamation"}
                        style={{margin: "0px 5px"}}
                    />
                    <strong>
                        {this.prepareStr(mainErrorText)}
                    </strong>
                </div>
                {this.prepareStr(errorDetails)}
            </ErrorMessage>
        );
    }
}

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        this.props.handleError(500, error, info);
        this.setState({hasError: true});
    }

    render() {
        if (this.state.hasError) {
            return <h1>Something went wrong.</h1>;
        }

        return this.props.children;
    }
}

export default Error;



// WEBPACK FOOTER //
// ./src/components/Error.js